<div class="provider-queue">

  <div class="provider-queue__header">
    <h3 class="provider-queue__title">
      {{ 'settings.provider_labels.title' | translate }}
    </h3>

    <!-- Says what "pending" actually means. Without this the state reads as a
         delay rather than the deliberate holding state it is. Full width, so it
         reads as a sentence instead of being squeezed into a column beside the
         buttons. -->
    <p class="provider-queue__hint">
      {{ 'settings.provider_labels.hint' | translate }}
    </p>

    <!-- One button per connected Gmail account, labelled with the address only.
         Repeating the word "Discover" on each was three times the width for no
         extra meaning; the group is captioned once instead. -->
    <div class="provider-queue__actions" *ngIf="gmailMailboxes.length">
      <span class="provider-queue__actions-caption">
        {{ 'settings.provider_labels.discover' | translate }}
      </span>
      <ui-button
        *ngFor="let mailbox of gmailMailboxes"
        type="secondary"
        [label]="mailbox.email"
        [isLoading]="discovering === mailbox.id"
        [disabled]="discovering !== null"
        data-testid="provider-label-discover"
        (click)="discover(mailbox.id)"></ui-button>
    </div>
  </div>

  <div class="provider-queue__status" *ngIf="loading" data-testid="provider-queue-loading">
    {{ 'common.loading' | translate }}
  </div>

  <!-- Nothing waiting is the normal state, not an error: Gmail needs a
       Discover, and Outlook categories only appear as mail carrying them
       arrives. -->
  <div class="provider-queue__status provider-queue__status--failed" *ngIf="loadFailed" data-testid="provider-queue-failed">
    <span>{{ 'settings.provider_labels.load_failed' | translate }}</span>
    <ui-button
      type="secondary"
      [label]="'common.retry' | translate"
      data-testid="provider-queue-retry"
      (click)="load()"></ui-button>
  </div>

  <div class="provider-queue__status" *ngIf="isEmpty" data-testid="provider-queue-empty">
    {{ 'settings.provider_labels.empty' | translate }}
  </div>

  <ul class="provider-queue__list" *ngIf="pending.length">
    <li class="provider-queue__row"
        data-testid="provider-label-row"
        [attr.data-ref-id]="ref.id"
        *ngFor="let ref of pending; trackBy: trackByRefId">

      <div class="provider-queue__row-main">
        <ui-svg-icon svgIcon="tag-cc" size="small" class="provider-queue__icon"></ui-svg-icon>
        <span class="provider-queue__name" [title]="ref.name">{{ ref.name }}</span>
      </div>

      <span class="provider-queue__account" [title]="ref.mailbox_email">
        {{ ref.mailbox_email }}
      </span>

      <div class="provider-queue__row-actions">
        <ui-button
          type="secondary"
          [label]="'settings.provider_labels.reject' | translate"
          [disabled]="deciding.has(ref.id)"
          data-testid="provider-label-reject"
          (click)="reject(ref)"></ui-button>
        <ui-button
          type="primary"
          [label]="'settings.provider_labels.accept' | translate"
          [isLoading]="deciding.has(ref.id)"
          data-testid="provider-label-accept"
          (click)="accept(ref)"></ui-button>
      </div>
    </li>
  </ul>
</div>
